<template>
    <div>
      <b-form-group label="Filter by SCN:" label-for="scn-select">
        <b-form-select
          id="scn-select"
          v-model="selectedScn"
          :options="scnOptions"
          class="mb-3"
        >
          <template #first>
            <b-form-select-option :value="null">All</b-form-select-option>
          </template>
        </b-form-select>
    </b-form-group>
      <b-table
        :fields=columnsTable
        :items="filteredItems"
        :per-page="perPage"
        :current-page="currentPage"
        small
      ></b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="items.length"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-2"
      ></b-pagination>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      items: {
        type: Array,
        required: true
      },
      perPage: {
        type: Number,
        default: 100
      }
    },
    data() {
      let columnsTable = [
				{ key: "sn", label: "# servicio" },
				{ key: "scr", label: "Referencia De canal" },
				{ key: "nr", label: "Tarifa" },
				{ key: "mon", label: "Moneda" },
				{ key: "pdt", label: "Fecha ride" },
        { key: "scn", label: "Canal de venta" }
			]
      return {
        currentPage: 1,
        selectedScn: null,
        columnsTable:columnsTable
      };
    },
    computed: {
      scnOptions() {
        const scns = this.items.map(item => item.scn).filter(Boolean);
        return [...new Set(scns)];
      },
      filteredItems() {
        if (!this.selectedScn) return this.items;
        return this.items.filter(item => item.scn === this.selectedScn);
      }
    },
    watch: {
      items() {
        this.currentPage = 1;
      },
      selectedScn() {
        this.currentPage = 1; // reset page when filter changes
      }
  }
  };
  </script>
  